module.exports = __webpack_public_path__ + "img/ts20.80c5cfcb.png";